(function fixNumberInputScrollChange() {
  /*
   * If any `wheel` listener being added on the input[type="number"] element or its ancestor, it will change
   * the behavior of the input element to:
   * - When the input element is focused and pointer is on the element, scrolling will cause change of the input value.
   *
   * External tracking scripts tend to add this kind of listener to the document,
   * so we need to prevent unexpected input behavior.
   * */

  document.addEventListener(
    'wheel',
    event => {
      if (
        document.activeElement === event.target &&
        event.target instanceof HTMLInputElement &&
        event.target.tagName === 'INPUT' &&
        event.target.type === 'number'
      ) {
        event.preventDefault();
      }
    },
    {
      passive: false,
    }
  );
})();
